import { useContext } from "react";
import { SportsCampsContext } from "../context/sportscamps-context";

const MoreInfo = (props) => {
	const { dictionaryWords } =
		useContext(SportsCampsContext);

	return (
		<footer className="c-fiche-sportcamp__footer">
			<a
				className="minimal ng-binding c-link--icon"
				title={props.cta}
			>
				{dictionaryWords.more}
				<i
					className="fa fa-solid fa-arrow-right"
					aria-hidden="true"
				></i>
			</a>
		</footer>
	);
};

export default MoreInfo;
